import api from '@/api'

export default {
  async getSiteSituationTypesList(context, payload) {
    const organizationId = payload.organizationId
    const siteId = payload.siteId
    const response = await api.situationType.getSiteSituationTypesList(
      organizationId,
      siteId
    )

    return response
  },

  async getSiteRules(context, payload) {
    const organizationId = payload.organizationId
    const siteId = payload.siteId
    const response = await api.situationType.getSiteRules(
      organizationId,
      siteId
    )

    return response
  },

  async getOrganizationRules(context, payload) {
    const organizationId = payload?.organizationId
    const response = await api.situationType.getOrganizationRules(
      organizationId
    )

    return response
  },

  async createSiteRule(context, payload) {
    const organizationId = payload.organizationId
    const siteId = payload.siteId
    const rule = payload.rule
    const response = await api.situationType.createSiteRule(
      organizationId,
      siteId,
      rule
    )

    return response
  },

  async createOrganizationRule(context, payload) {
    const organizationId = payload?.organizationId
    const rule = payload.rule
    const response = await api.situationType.createOrganizationRule(
      organizationId,

      rule
    )

    return response
  },

  async updateSiteRule(context, payload) {
    const organizationId = payload.organizationId
    const siteId = payload.siteId
    const ruleId = payload.ruleId
    const ruleData = payload.rule
    const response = await api.situationType.updateSiteRule(
      organizationId,
      siteId,
      ruleId,
      ruleData
    )

    return response
  },

  async updateOrganizationRule(context, payload) {
    const organizationId = payload?.organizationId
    const ruleId = payload.ruleId
    const ruleData = payload.rule
    const response = await api.situationType.updateOrganizationRule(
      organizationId,
      ruleId,
      ruleData
    )

    return response
  },

  async getOrganizationCatalog(context, payload) {
    const organizationId = payload.organizationId
    const response = await api.situationType.getOrganizationCatalog(
      organizationId
    )

    return response.data
  },

  async deleteOrganizationRule(context, payload) {
    const organizationId = payload.organizationId
    const ruleId = payload.ruleId
    const response = await api.situationType.removeOrganizationRule(
      organizationId,
      ruleId
    )

    return response.data
  },
}
